<!--2020/05/25 lqz-->
<template>
  <div class="ccui-home-index" v-if="isNoContent">
    <div class="emc-container">
      <!--购物车模块01Begin-->
      <div style="width: 100%">
        <div class="emc-top clearfix row">
          <div class="emc-title" style="margin-left: 15px;">
            租赁询价商品({{ emcGoodsNum }})
          </div>
          <span style="margin-left: 15px;font-size: 12px;color: #999;"
            >提示：仅支持单个分类单个或批量询价</span
          >
          <div class="flex">
            <UnitSelect
              v-if="false"
              :purchaseUndertakeOrgIdTreeData="unitSelectData"
              :purchaseOrgId="purchaseOrgId"
              :purchaseUndertakeOrgIdValue="purchaseUndertakeOrgIdValue"
            />
            <div class="emc-select-address">
              <label>配送至：</label>
              <el-area-selector
                style="width: 330px"
                :defaultArea="defaultAreaFix"
                @getAddressOf="getAddressOf"
                :place="leftPlace"
                :url="getAddressUrl"
                :headers="{ Authorization: this.access_token || '' }"
                :agentId="paramsData"
                v-if="!isAddressOne"
              ></el-area-selector>
            </div>
          </div>
        </div>
      </div>
      <!--购物车模块01End-->
      <div :style="{ 'min-height': minHeight }">
        <!--购物车交互Begin-->
        <ul class="emc-table-head">
          <li :style="{ width: tableWidth.selection + 40 + 'px' }">
            <!-- <label style="cursor: pointer" class="emc-checkbox-lable">
              <el-checkbox
                class="emc-checkbox"
                style="padding-right: 13px"
                :indeterminate="checkedEmcAll.isIndeterminate['isIndeter']"
                v-model="checkedEmcAll.selectedData['isChecked']"
                @change="handleCheckAllEmcChange"
              ></el-checkbox>
              全选
            </label>
            <span class="disabledFixCheckbox" v-if="!isCheckedState"></span> -->
          </li>
          <li :style="{ width: tableWidth.goodsName1 - 40 + 'px' }">商品</li>
          <li
            :style="{
              width: tableWidth.invoiceSubject - 40 + 'px',
              visibility: 'hidden'
            }"
          >
            开票主体
          </li>
          <li
            :style="{
              width: tableWidth.goodsPrice - 10 + 'px',
              'padding-right': '10px',
              'text-align': 'right'
            }"
          >
            单价
          </li>
          <li
            :style="{
              width: tableWidth.goodsNum + 'px',
              'text-align': 'center'
            }"
          >
            数量
          </li>
          <li
            :style="{
              width: tableWidth.goodsTotal - 10 + 'px',
              'text-align': 'right',
              'padding-right': '10px'
            }"
          >
            小计
          </li>
          <li
            :style="{
              width: tableWidth.op - 10 + 'px',
              'padding-left': '10px'
            }"
          >
            操作
          </li>
        </ul>
        <div
          class="category-container"
          v-for="(categoryItem, categoryIndex) of emcGoodsListData"
          :key="categoryIndex"
        >
          <div class="category-item">
            <el-checkbox
              class="emc-checkbox"
              :indeterminate="
                checkedCategoryAll.isIndeterminate[`${categoryItem.code}`]
              "
              :value="checkedCategoryAll.selectedData[`${categoryItem.code}`]"
              :disabled="categoryItem.shopdisabled"
              @change="
                val => {
                  handleCheckCategoryChange(val, categoryItem.code);
                }
              "
            ></el-checkbox>
            <span>{{ categoryItem.name }}</span>
          </div>
          <!--以店铺为基石 大循环Begin---------------------------------------------------------------------------->
          <div
            class="emc-goods-table"
            v-for="(item1, index1) of categoryItem.sons"
            :key="index1"
          >
            <!--判断第一级是否是店铺Begin-->
            <div class="emc-shop-goods-table" v-if="item1.type === 2">
              <ul class="emc-shop-goods-table-head">
                <li :style="{ width: tableWidth.selection + 'px' }">
                  <el-checkbox
                    class="emc-checkbox"
                    :indeterminate="
                      checkedShopAll.isIndeterminate[`${categoryItem.code}`][
                        `${item1.code}`
                      ]
                    "
                    :value="
                      checkedShopAll.selectedData[`${categoryItem.code}`][
                        `${item1.code}`
                      ]
                    "
                    :disabled="item1.shopdisabled"
                    @change="
                      val => {
                        handleCheckAllShopChange(
                          val,
                          categoryItem.code,
                          item1.code
                        );
                      }
                    "
                  ></el-checkbox>
                  <span
                    class="disabledFixCheckbox"
                    v-if="!isCheckedState"
                  ></span>
                </li>
                <li :style="{ width: tableWidth.goodsName1 - 40 + 200 + 'px' }">
                  <!-- 店铺： -->
                  <i
                    class="icon-shopingName shop-shopName"
                    v-if="item1.shopType"
                    >{{ getShopName(item1.shopType) }}</i
                  >
                  <i
                    class="icon-shopingType"
                    v-if="item1.isInternalUnit !== null"
                    >{{ getShopType(item1.isInternalUnit) }}</i
                  >
                  <a
                    :title="item1.name"
                    class="shopName"
                    v-if="item1.status === 1"
                    :href="VUE_APP_EMS_URL + 'notShop'"
                    target="_blank"
                    >{{ item1.name }}</a
                  >
                  <a
                    :title="item1.name"
                    class="shopName"
                    v-else
                    :href="VUE_APP_EMS_URL + '?shopId=' + item1.secretShopCode"
                    target="_blank"
                    >{{ item1.name }}</a
                  >
                </li>
                <li style="visibility: hidden;">
                  <span style="float:left">开票主体：</span
                  ><span :title="item1.businessName" class="invoiceSubject">{{
                    item1.businessName
                  }}</span
                  ><i
                    @click="copyInvoiceSubject(item1)"
                    class="icon-ccui-copy"
                    style="color:#0089EF;margin-left:10px;cursor: pointer;"
                  ></i>
                </li>
              </ul>
              <div class="emc-shop-goods-table-content">
                <el-checkbox-group
                  :value="
                    checkedForm.selectedData[`${categoryItem.code}`][
                      `${item1.code}`
                    ]
                  "
                >
                  <div v-for="(item2, index2) of item1.sons" :key="index2">
                    <!--无活动Begin--->
                    <div v-if="item2.type === 3" class="goods-shop-unactivity">
                      <ul
                        :class="[
                          checkedForm.selectedData[categoryItem.code][
                            item1.code
                          ].indexOf(item2.code) > -1
                            ? 'goods-shop-list active'
                            : 'goods-shop-list'
                        ]"
                      >
                        <li :style="{ width: tableWidth.selection + 'px' }">
                          <el-checkbox
                            :label="item2.code"
                            :key="item2.code"
                            :disabled="isdisabled(item2.skuStatus)"
                            class="emc-checkbox"
                            @change="
                              val => {
                                handleCheckedGoodsChange(
                                  val,
                                  categoryItem.code,
                                  item1.code,
                                  item2.code
                                );
                              }
                            "
                          ></el-checkbox>
                          <span class="line-circle"></span>
                          <span class="item-line"></span>
                          <span
                            class="disabledFixCheckbox"
                            v-if="!isCheckedState"
                          ></span>
                        </li>
                        <li :style="{ width: tableWidth.goodsName + 'px' }">
                          <!--商品Begin-->
                          <div class="goods-detail clearfix">
                            <div
                              class="goods-detail-state"
                              :style="
                                Number(item2.skuStatus) === 10
                                  ? 'width: 30px'
                                  : ''
                              "
                            >
                              {{
                                item2.skuStatus | toSkuStatusStr([1, 5, 7, 8])
                              }}
                            </div>
                            <a
                              :href="goodsDetailUrl + item2.code"
                              target="_blank"
                            >
                              <img
                                class="goods-img"
                                :src="item2.picUrl | goodsPicFormat"
                            /></a>
                            <div class="goods-name">
                              <a
                                :href="goodsDetailUrl + item2.code"
                                target="_blank"
                                :title="item2.name"
                              >
                                <span>{{ item2.name }}</span>
                              </a>
                              <div class="label-wrapper">
                                <i class="icon-shopingName">{{
                                  getEquipType(categoryItem.code)
                                }}</i>
                              </div>
                            </div>
                            <div
                              style="padding-left: 110px; padding-top: 6px;display: flex"
                            >
                              <Tag
                                :labelItem="item2"
                                :shopType="item1.shopType"
                                :contractType="item2.contractType"
                              />
                              <span class="low-price-label" v-if="item2.isLower"
                                >同款最低价</span
                              >
                            </div>
                          </div>
                          <div
                            class="goods-other"
                            v-if="item2.queryEmcGiftDetailBOS.length > 0"
                          >
                            <p
                              v-for="(itemGift,
                              indexGift) of item2.queryEmcGiftDetailBOS"
                              :key="indexGift"
                            >
                              【赠品】{{ itemGift.giftName }}... x{{
                                itemGift.num
                              }}
                            </p>
                          </div>
                          <div class="goods-dividing-line"></div>
                          <div
                            style="font-size: 12px;margin: 10px 0 0 36px;"
                            v-if="
                              !item2.isLower &&
                                item2.rows &&
                                item2.rows.length > 0
                            "
                          >
                            <span style="color:#898989;"
                              >【温馨提示】经平台比价后，有更低价商品</span
                            >
                            <span
                              @click="showModal(item2.rows, item2.code)"
                              style="color:#FF142F;margin-left: 10px;cursor: pointer;"
                              >查看低价商品</span
                            >
                          </div>
                          <!--商品End-->
                        </li>
                        <li
                          :style="{
                            width: tableWidth.goodsPrice - 10 + 'px',
                            'padding-right': '10px',
                            'text-align': 'right'
                          }"
                        >
                          <p class="goods-price">
                            <span v-if="Number(item2.skuStatus) == 10"
                              >******</span
                            >
                            <span v-else>
                              ￥ {{ item2.salePrice | toMoneyFormat }}
                            </span>
                          </p>
                          <p
                            class="goods-attribute"
                            v-if="
                              item2.downPrice &&
                                item2.isReducePrice &&
                                item2.skuStatus !== 10
                            "
                          >
                            <span>
                              降价：￥{{ item2.downPrice | toMoneyFormat }}
                            </span>
                          </p>
                          <p class="goods-price-select" style="display: none">
                            <!--暂无促销模型-->
                            <span class="promotion"
                              ><div class="goods-price-select-title">
                                促销<i class="icon-ccui-down"></i>
                              </div>
                              <div class="goods-price-select-box">
                                <ul>
                                  <li></li>
                                </ul>
                              </div>
                            </span>
                          </p>
                          <p
                            class="goods-price-select"
                            v-if="
                              item2.ladderPrice &&
                                item2.skuStatus !== 10 &&
                                item2.flag != 2
                            "
                          >
                            <!--是否阶梯价-->
                            <span class="set-price"
                              ><div class="goods-price-select-title">
                                阶梯价<i class="icon-ccui-down"></i>
                              </div>
                              <div class="goods-price-select-box">
                                <ul>
                                  <li>
                                    <table>
                                      <tbody>
                                        <tr
                                          v-for="(itemLadder,
                                          indexLaddeer) of item2.ladderPriceBOS"
                                          :key="indexLaddeer"
                                          :class="[
                                            Number(item2.num) >=
                                              Number(itemLadder.downString) &&
                                            Number(item2.num) <=
                                              Number(
                                                itemLadder.upString || 100000
                                              )
                                              ? 'active'
                                              : ''
                                          ]"
                                        >
                                          <td
                                            v-if="itemLadder.upString"
                                            style="text-align: right"
                                          >
                                            {{ itemLadder.downString }}-{{
                                              itemLadder.upString
                                            }}{{ item2.unitName }}：
                                          </td>
                                          <td v-else style="text-align: right">
                                            ≥{{ itemLadder.downString
                                            }}{{ item2.unitName }}：
                                          </td>
                                          <td>
                                            ¥{{
                                              itemLadder.salePrice
                                                | toMoneyFormat
                                            }}
                                          </td>
                                        </tr>
                                        <tr></tr>
                                      </tbody>
                                    </table>
                                  </li>
                                </ul>
                              </div>
                            </span>
                          </p>
                        </li>
                        <li
                          :style="{
                            width: tableWidth.goodsNum + 'px',
                            'text-align': 'center'
                          }"
                        >
                          <div>
                            <el-input-number
                              v-model="objAllNum[item2.code]"
                              debounce
                              @focus="focusGoodsNum()"
                              @blur="blurGoodsNum"
                              @change="
                                value => {
                                  handleChangeGoodsNum(
                                    value,
                                    item2,
                                    item1.code,
                                    categoryItem.code
                                  );
                                }
                              "
                              :min="item2.minPurchaseNum || 1"
                              label=""
                            ></el-input-number>
                            <div class="stockTip">
                              <span
                                v-if="
                                  item2.minPurchaseNum &&
                                    parseInt(item2.minPurchaseNum) > 1
                                "
                                class="pr-5"
                                >起订量：{{ item2.minPurchaseNum }}
                              </span>
                              <span
                                class="highlight"
                                v-if="
                                  item2.skuStatus !== 1 && item2.skuStatus !== 7
                                "
                                >{{
                                  item2.skuStatus
                                    | toSkuStatusStr([2, 3, 4, 6, 7, 8])
                                }}</span
                              >
                              <span v-else>{{
                                item2.skuStatus
                                  | toSkuStatusStr([2, 3, 4, 6, 7, 8])
                              }}</span>
                            </div>
                          </div>
                        </li>
                        <li
                          :style="{
                            width: tableWidth.goodsTotal - 10 + 'px',
                            'text-align': 'right',
                            'padding-right': '10px'
                          }"
                        >
                          <div class="goods-curr-total">
                            <div v-if="Number(item2.skuStatus) == 10">
                              ******
                            </div>
                            <div v-else>
                              ￥{{ item2.total | toMoneyFormat }}
                            </div>
                            <!--div
                            class="goods-curr-total-discount"
                            v-if="item2.downPrice"
                          >
                            减￥{{ item2.downPrice | toMoneyFormat }}
                          </div-->
                            <!--div v-if="item2.downPrice">
                            ￥{{
                              (item2.total - item2.downPrice) | toMoneyFormat
                            }}
                          </div-->
                          </div>
                        </li>
                        <li
                          :style="{
                            width: tableWidth.op - 10 + 'px',
                            'padding-left': '10px'
                          }"
                        >
                          <a
                            href="javascript:;"
                            class="deletedCurr"
                            @click="deletedCurr(item2, item1, categoryItem)"
                            >删除</a
                          >
                          <!-- <span
                            href="javascript:;"
                            class="removeCurr"
                            @click="removeCurr(item2)"
                            >移到我的关注</span
                          > -->
                        </li>
                      </ul>
                    </div>
                    <!--无活动End-->
                    <!--有活动Begin-->
                    <div v-if="item2.type === 1" class="goods-shop-activity">
                      <div class="goods-shop-activity-head">
                        <span>满减</span>{{ item2.name }}>
                        <a href="javascript:;">去凑单</a>
                        <p class="goods-shop-totalprice">
                          ￥{{ item2.totalSelectedPrice | toMoneyFormat }}
                        </p>
                        <p class="goods-shop-totaldisprice">
                          减￥{{ item2.minusPrice | toMoneyFormat }}
                        </p>
                      </div>
                      <div class="goods-shop-activity-list">
                        <ul
                          v-for="(item3, index3) of item2.sons"
                          :key="index3"
                          :class="[
                            checkedForm.selectedData[categoryItem.code][
                              item1.code
                            ].indexOf(item3.code) > -1
                              ? 'goods-shop-list active'
                              : 'goods-shop-list'
                          ]"
                        >
                          <li :style="{ width: tableWidth.selection + 'px' }">
                            <el-checkbox
                              :label="item3.code"
                              :key="item3.code"
                              :disabled="isdisabled(item3.skuStatus)"
                              class="emc-checkbox"
                              @change="
                                val => {
                                  handleCheckedGoodsChange(
                                    val,
                                    categoryItem.code,
                                    item1.code,
                                    item3.code
                                  );
                                }
                              "
                            ></el-checkbox>
                            <span class="line-circle"></span>
                            <span class="item-line"></span>
                            <span
                              class="disabledFixCheckbox"
                              v-if="!isCheckedState"
                            ></span>
                          </li>
                          <li :style="{ width: tableWidth.goodsName + 'px' }">
                            <!--商品Begin-->
                            <div class="goods-detail clearfix">
                              <div
                                class="goods-detail-state"
                                :style="
                                  Number(item3.skuStatus) === 10
                                    ? 'width: 30px'
                                    : ''
                                "
                              >
                                {{
                                  item3.skuStatus | toSkuStatusStr([1, 5, 7, 8])
                                }}
                              </div>
                              <a
                                :href="goodsDetailUrl + item2.code"
                                target="_blank"
                              >
                                <img
                                  class="goods-img"
                                  :src="item3.picUrl | goodsPicFormat"
                                />
                              </a>
                              <div class="goods-name">
                                <a
                                  :href="goodsDetailUrl + item2.code"
                                  target="_blank"
                                  :title="item3.name"
                                >
                                  <span>{{ item3.name }}</span>
                                </a>
                                <i class="icon-shopingName">{{
                                  getEquipType(categoryItem.code)
                                }}</i>
                              </div>
                            </div>
                            <div
                              class="goods-other"
                              v-if="item3.queryEmcGiftDetailBOS.length > 0"
                            >
                              <p
                                v-for="(itemGift,
                                indexGift) of item3.queryEmcGiftDetailBOS"
                                :key="indexGift"
                              >
                                【赠品】{{ itemGift.giftName }}... x{{
                                  itemGift.num
                                }}
                              </p>
                            </div>
                            <div class="goods-dividing-line"></div>
                            <!--商品End-->
                          </li>
                          <li
                            :style="{
                              width: tableWidth.goodsPrice - 10 + 'px',
                              'padding-right': '10px',
                              'text-align': 'right'
                            }"
                          >
                            <p class="goods-price">
                              <span v-if="Number(item3.skuStatus) == 10"
                                >******</span
                              >
                              <span v-else>
                                ￥ {{ item3.salePrice | toMoneyFormat }}
                              </span>
                            </p>
                            <p class="goods-attribute" v-if="item3.downPrice">
                              <span
                                v-if="
                                  item2.isReducePrice && item2.skuStatus !== 10
                                "
                              >
                                降价：￥{{ item3.downPrice | toMoneyFormat }}
                              </span>
                            </p>
                            <p class="goods-price-select" style="display: none">
                              <!--暂无促销模型-->
                              <span class="promotion"
                                ><div class="goods-price-select-title">
                                  促销<i class="icon-ccui-down"></i>
                                </div>
                                <div class="goods-price-select-box">
                                  <ul>
                                    <li></li>
                                  </ul>
                                </div>
                              </span>
                            </p>
                            <p
                              class="goods-price-select"
                              v-if="
                                item3.ladderPrice &&
                                  item3.skuStatus !== 10 &&
                                  item3.flag != 2
                              "
                            >
                              <!--是否阶梯价-->
                              <span class="set-price"
                                ><div class="goods-price-select-title">
                                  阶梯价<i class="icon-ccui-down"></i>
                                </div>
                                <div class="goods-price-select-box">
                                  <ul>
                                    <li>
                                      <table>
                                        <tbody>
                                          <tr
                                            v-for="(itemLadder,
                                            indexLaddeer) of item2.ladderPriceBOS"
                                            :key="indexLaddeer"
                                            :class="[
                                              Number(item2.num) >=
                                                Number(itemLadder.downString) &&
                                              Number(item2.num) <
                                                Number(itemLadder.upString)
                                                ? 'active'
                                                : ''
                                            ]"
                                          >
                                            <td
                                              v-if="itemLadder.upString"
                                              style="text-align: right"
                                            >
                                              {{ itemLadder.downString }}-{{
                                                itemLadder.upString
                                              }}{{ item2.unitName }}：
                                            </td>
                                            <td
                                              v-else
                                              style="text-align: right"
                                            >
                                              ≥{{ itemLadder.downString
                                              }}{{ item2.unitName }}：
                                            </td>
                                            <td>
                                              ¥{{
                                                itemLadder.salePrice
                                                  | toMoneyFormat
                                              }}
                                            </td>
                                          </tr>
                                          <tr></tr>
                                        </tbody>
                                      </table>
                                    </li>
                                  </ul>
                                </div>
                              </span>
                            </p>
                          </li>
                          <li
                            :style="{
                              width: tableWidth.goodsNum + 'px',
                              'text-align': 'center'
                            }"
                          >
                            <div>
                              <el-input-number
                                v-model="objAllNum[item3.code]"
                                debounce
                                @focus="focusGoodsNum()"
                                @blur="blurGoodsNum"
                                @change="
                                  value => {
                                    handleChangeGoodsNum(
                                      value,
                                      item3,
                                      item2.code,
                                      categoryItem.code
                                    );
                                  }
                                "
                                :min="item3.minPurchaseNum || 1"
                                label=""
                              ></el-input-number>
                              <div class="stockTip">
                                <span
                                  v-if="
                                    item3.minPurchaseNum &&
                                      parseInt(item3.minPurchaseNum) > 1
                                  "
                                  class="pr-5"
                                  >起订量：{{ item3.minPurchaseNum }}
                                </span>
                                <span
                                  class="highlight"
                                  v-if="
                                    item3.skuStatus !== 1 &&
                                      item3.skuStatus !== 7
                                  "
                                  >{{
                                    item3.skuStatus
                                      | toSkuStatusStr([2, 3, 4, 6, 7, 8])
                                  }}</span
                                >
                                <span v-else>{{
                                  item3.skuStatus
                                    | toSkuStatusStr([2, 3, 4, 6, 7, 8])
                                }}</span>
                              </div>
                            </div>
                          </li>
                          <li
                            :style="{
                              width: tableWidth.goodsTotal - 10 + 'px',
                              'text-align': 'right',
                              'padding-right': '10px'
                            }"
                          >
                            <div class="goods-curr-total">
                              <div v-if="Number(item2.skuStatus) == 10">
                                ******
                              </div>
                              <div v-else>
                                ￥{{ item3.total | toMoneyFormat }}
                              </div>
                              <!--div
                              class="goods-curr-total-discount"
                              v-if="item3.downPrice"
                            >
                              减￥{{ item3.downPrice | toMoneyFormat }}
                            </div-->
                              <!--div v-if="item3.downPrice">
                              ￥{{
                                (item3.total - item3.downPrice) | toMoneyFormat
                              }}
                            </div-->
                            </div>
                          </li>
                          <li
                            :style="{
                              width: tableWidth.op - 10 + 'px',
                              'padding-left': '10px'
                            }"
                          >
                            <a
                              href="javascript:;"
                              class="deletedCurr"
                              @click="deletedCurr(item3, item2, categoryItem)"
                              >删除</a
                            >
                            <span
                              href="javascript:;"
                              class="removeCurr"
                              @click="removeCurr(item3)"
                              >移到我的关注</span
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!--有活动End-->
                  </div>
                </el-checkbox-group>
              </div>
            </div>
            <!--判断第一级是否是店铺End-->
            <!--判断第一级是活动Begin 咱无第一级是活动情况-->
            <!--判断第一级是活动End-->
          </div>
          <!--大循环End---------------------------------------------------------------------------->
        </div>
        <!--已下架的商品-->
        <div class="emc-shop-goods-undercarriage-table">
          <ul
            class="goods-shop-list"
            v-for="(item, $index) of invalidGoodsListData"
            :key="$index"
          >
            <li :style="{ width: tableWidth.selection + 'px' }"></li>
            <li :style="{ width: tableWidth.goodsName + 'px' }">
              <!--商品Begin-->
              <div class="goods-detail clearfix">
                <div
                  class="goods-detail-state"
                  :style="Number(item.skuStatus) == 10 ? 'width: 30px' : ''"
                >
                  {{ item.skuStatus | toSkuStatusStr() }}
                </div>
                <img class="goods-img" :src="item.picUrl | goodsPicFormat" />
                <!--<p class="goods-name" :title="item.name" >
                  <span>{{ item.name }}</span>
              </p>-->

                <p class="goods-name" :title="item.name">
                  <span>{{ item.name }}</span>
                </p>
              </div>
              <div class="goods-dividing-line"></div>
              <!--商品End-->
            </li>
            <li
              :style="{
                width: tableWidth.goodsPrice - 10 + 'px',
                'padding-right': '10px',
                'text-align': 'right'
              }"
            >
              <p class="good-default">
                <span v-if="Number(item.skuTwoStatus) == 10">******</span>
                <span v-else>￥ {{ item.salePrice | toMoneyFormat }}</span>
              </p>
            </li>
            <li
              :style="{
                width: tableWidth.goodsNum + 'px',
                'text-align': 'center'
              }"
            >
              <div>
                <div class="good-default">
                  {{ item.num }}
                </div>
              </div>
            </li>
            <li
              :style="{
                width: tableWidth.goodsTotal - 10 + 'px',
                'text-align': 'right',
                'padding-right': '10px'
              }"
            >
              <div class="good-default">
                <div v-if="Number(item.skuTwoStatus) == 10">******</div>
                <div v-else>￥{{ item.total | toMoneyFormat }}</div>
              </div>
            </li>
            <li
              :style="{
                width: tableWidth.op - 10 + 'px',
                'padding-left': '10px'
              }"
            >
              <a
                href="javascript:;"
                class="deletedCurr"
                @click="deletedCurr(item)"
                >删除</a
              >
              <span
                href="javascript:;"
                class="removeCurr"
                @click="removeCurr(item)"
                >移到我的关注</span
              >
            </li>
          </ul>
        </div>

        <!--购物车交互End-->
      </div>
      <!--总合Begin-->
      <div class="emc-all-total" id="emc-all-total">
        <div class="emc-all-total-l clearfix">
          <!-- <label>
            <el-checkbox
              class="emc-checkbox"
              style="padding-right: 19px"
              :indeterminate="checkedEmcAll.isIndeterminate['isIndeter']"
              v-model="checkedEmcAll.selectedData['isChecked']"
              @change="handleCheckAllEmcChange"
            ></el-checkbox>
            全选
          </label>
          <span class="disabledFixCheckbox" v-if="!isCheckedState"></span> -->
          <a href="javascript:;" @click="deletedEmcGoods()">删除选中商品</a>
          <!-- <a
            style="cursor: default"
            href="javascript:;"
            @click="removeEmcGoods()"
            >移到我的关注</a
          > -->
        </div>
        <div class="emc-all-total-r clearfix">
          <div class="emc-all-total-r-slected">
            已选商品<span>{{ selectemcGoodsNum }}</span
            >种
          </div>
          <!-- <div class="emc-all-total-r-slected-title">
            <span class="emc-all-total-r-slected-title-h2"
              >总计（不含运费）</span
            ><span class="emc-all-total-r-slected-title-p"
              >￥{{ selectemcGoodsTotalPrice | toMoneyFormat }}</span
            >
            <div
              v-if="selectemcGoodsTotalDisPrice"
              class="emc-all-total-r-slected-attr"
            >
              促销：-￥{{ selectemcGoodsTotalDisPrice | toMoneyFormat }}
            </div>
          </div> -->
          <a
            href="javascript:;"
            class="emc-all-submit-order"
            @click="inquiryPrice"
            >立即询价</a
          >
        </div>
      </div>
      <!--总和End-->
    </div>
    <!--总和Fix Begin-->
    <div class="emc-all-total-fix" v-show="emcTotalFixDefault">
      <!--:style="{ display: emcTotalFix ? 'block' : 'none' }"-->
      <div class="emc-all-total">
        <div class="emc-all-total-l clearfix">
          <!-- <label>
            <el-checkbox
              class="emc-checkbox"
              style="padding-right: 19px"
              :indeterminate="checkedEmcAll.isIndeterminate['isIndeter']"
              v-model="checkedEmcAll.selectedData['isChecked']"
              @change="handleCheckAllEmcChange"
            ></el-checkbox>
            全选
          </label>
          <span class="disabledFixCheckbox" v-if="!isCheckedState"></span> -->
          <a href="javascript:;" @click="deletedEmcGoods()">删除选中商品</a>
          <!-- <a
            style="cursor: default"
            href="javascript:;"
            @click="removeEmcGoods()"
            >移到我的关注</a
          > -->
        </div>
        <div class="emc-all-total-r clearfix">
          <div class="emc-all-total-r-slected">
            已选商品<span>{{ selectemcGoodsNum }}</span
            >种
          </div>
          <!-- <div class="emc-all-total-r-slected-title">
            <span class="emc-all-total-r-slected-title-h2"
              >总计（不含运费）</span
            ><span class="emc-all-total-r-slected-title-p"
              >￥{{ selectemcGoodsTotalPrice | toMoneyFormat }}</span
            >
            <div
              v-if="selectemcGoodsTotalDisPrice"
              class="emc-all-total-r-slected-attr"
            >
              促销：-￥{{ selectemcGoodsTotalDisPrice | toMoneyFormat }}
            </div>
          </div> -->
          <a
            href="javascript:;"
            class="emc-all-submit-order"
            @click="inquiryPrice"
            >立即询价</a
          >
        </div>
      </div>
    </div>
  </div>
  <div class="ccui-home-index" v-else>
    <div class="emc-container">
      <div style="width: 100%">
        <div class="emc-top clearfix row">
          <div class="emc-title" style="margin-left: 15px;">
            租赁询价商品({{ emcGoodsNum || 0 }})
          </div>
        </div>
      </div>
      <NoContent v-if="flagIsNoContent" />
    </div>
  </div>
</template>

<script>
import {
  viewProvince,
  qryAddress,
  queryEmcListClp,
  selected,
  deleteSku,
  modifyNumTotal,
  qryDefault,
  qryUnitOrgTree
} from "@/api/emc-api";
import Cookies from "js-cookie";
import { addUrlPerFix } from "@/utils";
import NoContent from "@/components/noContent";
import UnitSelect from "./components/unitSelect/index.vue";
import Tag from "./components/tag/index.vue";
import { isdisabled } from "@/filters/index.js";
import { Emccompute } from "@/utils/emc-compute.js";
const VUE_APP_EMI_URL = addUrlPerFix(process.env.VUE_APP_EMI_URL);
const VUE_APP_EMS_URL = addUrlPerFix(process.env.VUE_APP_EMS_URL);
const placeAnOrderUrl = addUrlPerFix(process.env.VUE_APP_PLACE_AN_ORDER_URL);
const inquiryPriceUrl =
  addUrlPerFix(process.env.VUE_APP_EMPO_URL) + "/inquiryPlanList";
export default {
  name: "emc-home",
  components: {
    NoContent,
    UnitSelect,
    Tag
  },
  data() {
    return {
      flag: true,
      activeName: "first",
      isAddressOne: true,
      isNoContent: false,
      flagIsNoContent: false,
      access_token: Cookies.get("access_token"),
      minHeight: "auto",
      clientHeight: 0,
      emcTotalFixDefault: false,
      emcTotalFix: false,
      emcTotalOffTop: 0,
      isCheckedState: false, // 判断是否可以选中  每次选中加载完后可再次进行选中
      getAddressUrl:
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) +
        "/apis/emc/cart/qryAddressOfFourth",
      isdisabled: isdisabled,
      leftPlace: "right",
      paramsData: "100108",
      VUE_APP_EMS_URL: VUE_APP_EMS_URL,
      goodsDetailUrl: VUE_APP_EMI_URL,
      dialogVisible: false,
      isBlurFinish: true, // 数量失焦事件是否完成
      currClick: 0, // 1 当前点击为提交订单模块
      isNumChange: false, // 改变数量是否成功
      defaultAreaFix: [
        { code: 1, name: "北京市" },
        { code: 2802, name: "东城区" },
        { code: 2821, name: "内环到三环里" }
      ],
      defaultArea: [],
      selectCity: [],
      emcGoodsNum: 0,
      selectemcGoodsNum: 0, //已选择商品总数量
      selectemcGoodsTotalPrice: 0, // 已选择商品的总价格
      selectemcGoodsTotalDisPrice: 0, //已选商品总优惠
      checkedEmcAll: {
        //购物车全选
        selectedData: { isChecked: false }, //购物车中是否全部勾选商品
        isIndeterminate: { isIndeter: false } //购物车中半选状态
      },
      objAllNum: {},
      checkedForm: {
        //各个大类下各个店铺已勾选的商品
        selectedData: {}
      },
      checkedFormCategory: {
        //记录各个大类下已勾选的商品
        selectedData: {}
      },
      checkedShopAll: {
        //店铺中是否全部勾选商品
        selectedData: {},
        //店铺的半选状态
        isIndeterminate: {}
      },
      checkedCategoryAll: {
        //商品大类中是否全部勾选商品
        selectedData: {},
        //商品大类中的半选状态
        isIndeterminate: {}
      },
      checkedShopGoods: {
        //记录各个大类下各个店铺所有可选的商品
        goodsData: {}
      },
      checkedCategoryGoods: {
        //记录各个大类下所有可选的商品
        goodsData: {}
      },
      checkedEmcGoods: {
        // 购物车中所有商品
        goodsData: {}
      },
      tableWidth: {
        selection: 42,
        goodsName: 520,
        goodsName1: 300,
        invoiceSubject: 245,
        goodsPrice: 136,
        goodsNum: 160,
        goodsTotal: 170,
        op: 114
      },
      emcGoodsListData: [],
      invalidGoodsListData: [],
      addressOptions: [],
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          if (level === 0) {
            // 第一级加载省份
            viewProvince({})
              .then(res => {
                if (res.data.code === "0") {
                  const nodes = res.data.data.map(item => {
                    return {
                      label: item.addressAbbr,
                      value: item.addressCode,
                      leaf: false
                    };
                  });
                  resolve(nodes);
                }
              })
              .catch(e => {
                console.log(e);
              });
          } else {
            qryAddress({ addressCode: node.value })
              .then(res => {
                if (res.data.code === "0") {
                  const nodes = res.data.data.map(item => {
                    return {
                      label: item.addressAbbr,
                      value: item.addressCode,
                      leaf: item.lastFlag
                    };
                  });
                  resolve(nodes);
                }
              })
              .catch(e => {
                console.log(e);
              });
            console.log("sd");
          }
        }
      },
      unitSelectData: [],
      purchaseOrgId: "",
      purchaseUndertakeOrgIdValue: "",
      isMonofile: false,
      isFlag: true,
      addCardStatus: [1, 5, 7, 8],
      checkList: [],
      backCartCartNum: 2
    };
  },

  beforeRouteLeave(to, form, next) {
    Cookies.remove("backCartCartData");
  },

  mounted() {
    document.title = "我的购物车 - 中交云租";
    if (sessionStorage.getItem("userInfo")) {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      const token = userInfo.userToken;
      if (!token) {
        this.$store.commit("SET_IS_SHOW_DIALOG", true);
      }
    }

    if (Number(this.backCartCartNum) === 1) {
      if (Cookies.get("formCartSelect")) {
        let formCartSelectData = JSON.parse(Cookies.get("formCartSelect"));
        Cookies.set("backCartCartData", JSON.stringify(formCartSelectData), {
          path: "/",
          domain: "iccec.cn"
        });
      }
    }

    if (!Cookies.get("backCartCartData")) {
      Cookies.set("backCartCartNum", 2, {
        path: "/",
        domain: "iccec.cn"
      });
    }
    this.backCartCartNum = Number(Cookies.get("backCartCartNum"));
    if (Number(this.backCartCartNum) !== 1) {
      Cookies.remove("backCartCartData", {
        path: "/",
        domain: "iccec.cn"
      });
    } else {
      if (Cookies.get("formCartSelect")) {
        let formCartSelectData = JSON.parse(Cookies.get("formCartSelect"));
        Cookies.set("backCartCartData", JSON.stringify(formCartSelectData), {
          path: "/",
          domain: "iccec.cn"
        });
      }
    }

    // let IPCodeList = Cookies.get("IPCodeList");
    // if (IPCodeList) {
    //   this.defaultAreaFix = JSON.parse(IPCodeList);
    //   this.defaultArea = JSON.parse(JSON.stringify(this.defaultAreaFix));
    //   this.getQuerCartsAll(true);
    // } else {
    //   this.defaultAreaFix = [
    //     {
    //       name: "北京",
    //       code: 1
    //     },
    //     {
    //       name: "朝阳区",
    //       code: 72
    //     },
    //     {
    //       name: "三环以内",
    //       code: 2799
    //     }
    //   ];
    //  // this.GetQryDefault();
    // }

    this.getInfoTree();
    //  this.GetQryDefault();
    window.addEventListener("scroll", this.handleScrollx, true);
    // window.onresize = this.handleScrollx

    if (document.documentElement.clientWidth > 1280) {
      this.tableWidth = {
        selection: 42,
        goodsName: 520,
        goodsName1: 300,
        invoiceSubject: 245,
        goodsPrice: 136,
        goodsNum: 160,
        goodsTotal: 170,
        op: 114
      };
    } else {
      this.tableWidth = {
        selection: 42,
        goodsName: 430,
        goodsName1: 255,
        invoiceSubject: 200,
        goodsPrice: 106,
        goodsNum: 160,
        goodsTotal: 170,
        op: 114
      };
    }
  },
  methods: {
    goMallGoodsPage() {
      location.href = location.origin + `/index`;
    },
    getShopName(shopType) {
      switch (shopType) {
        case 1:
          return "自营店";
        case 2:
          return "联营店";
        case 3:
          return "第三方";
        case 4:
          return "二级集采";
        case 5:
          return "云租店铺";
        default:
          return "";
      }
    },
    getShopType(isInternalUnit) {
      const isInternalUnitMap = new Map([
        [1, "内部"],
        [0, "外部"]
      ]);
      return isInternalUnitMap.get(isInternalUnit) || "";
    },
    getEquipType(code) {
      const codeMap = new Map([
        ["61", "设备"],
        ["62", "设备"],
        ["63", "周材"]
      ]);
      return codeMap.get(code) || "";
    },
    copyInvoiceSubject(item) {
      var cInput = document.createElement("input");
      cInput.value = item.businessName;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand("copy");
      this.$message({
        message: "复制成功",
        type: "success",
        ccuiCustom: true,
        showClose: true
      });
    },
    async GetQryDefault() {
      try {
        // 请求默认地址
        await qryDefault({
          isShowPageLoading: true
        })
          .then(res => {
            if (res.data.code === "0") {
              this.$nextTick(() => {
                this.isAddressOne = false;
              });
              if (this.isAddressOne) {
                if (Cookies.get("IPCodeList")) {
                  this.defaultAreaFix = JSON.parse(Cookies.get("IPCodeList"));
                  this.defaultArea = Object.assign(this.defaultAreaFix);
                } else {
                  this.defaultAreaFix = res.data.data;
                  this.defaultArea = Object.assign(this.defaultAreaFix);
                }
              }
            }
            // if (res.data.code === "0" && res.data.data && res.data.data.length > 0) {
            //   this.defaultAreaFix = res.data.data;
            // }
            // this.defaultArea = JSON.parse(JSON.stringify(this.defaultAreaFix));
          })
          .catch(e => {
            console.log(e);
            this.defaultArea = JSON.parse(JSON.stringify(this.defaultAreaFix));
          });
        await this.getQuerCartsAll(true);
      } catch (err) {
        console.log(err);
      }
    },
    getQuerCartsAll(isloading) {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        // 判断是ie浏览器
        this.emcTotalFixDefault = false;
        this.emcTotalFix = false;
      }
      try {
        queryEmcListClp({
          isShowPageLoading: isloading,
          provinceCode: this.defaultArea[0].code,
          cityCode: this.defaultArea[1].code,
          countyCode: this.defaultArea[2].code,
          townCode:
            this.defaultArea.length > 3 ? this.defaultArea[3].code : "0",
          purchaseOrgId: this.purchaseOrgId
        }).then(async res => {
          if (res.data.code === "0") {
            // res.data.data = res.data.data.queryEmcS;
            this.emcGoodsNum = res.data.data.countCartItem;
            this.emcGoodsListData = res.data.data.sons;
            // this.emcGoodsListData = [
            //   {
            //     code: "c01",
            //     name: "型材",
            //     type: 1,
            //     sons: res.data.data.sons
            //   },
            //   {
            //     code: "c02",
            //     name: "电线电联",
            //     type: 1,
            //     sons: res.data.data.sons
            //   }
            // ];
            if (
              this.emcGoodsListData.length === 0 &&
              res.data.data.skuList.length === 0
            ) {
              this.isNoContent = false;
              this.flagIsNoContent = true;
            } else if (
              this.emcGoodsListData.length > 0 &&
              res.data.data.skuList.length > 0
            ) {
              this.isNoContent = true;
              this.flagIsNoContent = true;
            } else if (
              this.emcGoodsListData.length > 0 &&
              res.data.data.skuList.length === 0
            ) {
              this.isNoContent = true;
              this.flagIsNoContent = true;
            } else if (
              this.emcGoodsListData.length === 0 &&
              res.data.data.skuList.length > 0
            ) {
              this.isNoContent = true;
              this.flagIsNoContent = true;
            } else {
              this.isNoContent = true;
              this.flagIsNoContent = true;
            }
            this.selectemcGoodsNum = res.data.data.selectedSkuNum; //已选总商品种类
            this.selectemcGoodsTotalPrice = res.data.data.afterPromotionPrice; //总优惠后价格
            this.selectemcGoodsTotalDisPrice =
              res.data.data.selectSkuPromotionPrice; //总优惠
            // 购物车中所有skuis集合
            this.checkedEmcGoods.goodsData[
              "all"
            ] = Emccompute.queryShopAllGoodsCode([], this.emcGoodsListData);
            // 失效商品先用别的商品顶一下
            this.invalidGoodsListData = res.data.data.skuList;

            // =》下面需要用this.checkedEmcGoods.goodsData["all"]
            this.emcGoodsListDataFilter(this.emcGoodsListData);
          } else {
            this.emcGoodsListData = [];
            this.invalidGoodsListData = [];
          }
          this.isCheckedState = true;

          this.$nextTick(() => {
            this.minHeight = `${document.documentElement.clientHeight -
              206 -
              456}px`;
            this.clientHeight = document.documentElement.clientHeight;
            if (document.getElementById("emc-all-total")) {
              this.emcTotalOffTop =
                document.getElementById("emc-all-total").offsetTop + 238;
            }

            this.handleScrollx(1);
          });
        });
      } catch (e) {
        this.isCheckedState = true;
        console.log(e);
      }
    },

    getAddressOf(cityValue) {
      let [pcode, cityName] = [[], []];
      cityValue.forEach(i => {
        pcode.push(i.code);
        cityName.push(i.name);
      });
      Cookies.set("IPCodeList", cityValue, { path: "/", domain: "iccec.cn" });
      // 购物车业务
      this.defaultArea = cityValue;
      this.getQuerCartsAll(true);
    },
    emcGoodsListDataFilter(data) {
      data.forEach(res => {
        if (res.type === 1) {
          // 各个大类下选中商品的集合
          this.checkedFormCategory.selectedData[
            res.code
          ] = Emccompute.queryShopSelectedGoodsCode([], res.sons);
          // 各个大类下可选商品的集合
          this.checkedCategoryGoods.goodsData[
            res.code
          ] = Emccompute.queryShopAllGoodsCode([], res.sons);
          this.checkedForm.selectedData[res.code] = {};
          this.checkedShopGoods.goodsData[res.code] = {};
          // 大类的选中与否 初始化
          this.checkedCategoryAll.selectedData[res.code] = false;
          this.checkedCategoryAll.isIndeterminate[res.code] = false;
          // 店铺的选中与否 初始化
          this.checkedShopAll.selectedData[res.code] = {};
          this.checkedShopAll.isIndeterminate[res.code] = {};
          // 店铺中选中的商品集合
          res.sons.forEach(item => {
            this.checkedForm.selectedData[res.code][
              item.code
            ] = Emccompute.queryShopSelectedGoodsCode([], item.sons);

            // 店铺的选中与否 初始化
            this.checkedShopAll.selectedData[res.code][item.code] = false;
            this.checkedShopAll.isIndeterminate[res.code][item.code] = false;
            // 店铺中可选商品的集合
            this.checkedShopGoods.goodsData[res.code][
              item.code
            ] = Emccompute.queryShopAllGoodsCode([], item.sons);
            // 判断店铺中可选商品是否为0 lqz测试
            if (
              this.checkedShopGoods.goodsData[res.code][item.code].length === 0
            ) {
              item.shopdisabled = true;
            } else {
              item.shopdisabled = false;
            }
          });
        }
        // if (res.type === 2) {
        //   this.checkedForm.selectedData[
        //     res.code
        //   ] = Emccompute.queryShopSelectedGoodsCode([], res.sons); // 已选择的商品code
        //   this.checkedShopAll.selectedData[res.code] = false;
        //   this.checkedShopAll.isIndeterminate[res.code] = false;
        //   this.checkedShopGoods.goodsData[
        //     res.code
        //   ] = Emccompute.queryShopAllGoodsCode([], res.sons);
        //   // 判断店铺中可选商品是否为0 lqz测试
        //   if (this.checkedShopGoods.goodsData[res.code].length === 0) {
        //     res.shopdisabled = true;
        //   } else {
        //     res.shopdisabled = false;
        //   }
        //   this.judgeShopCheckAll(res.code); //判断店铺是否全选
        //   this.judgeShopIsIndeter(res.code); // 判断店铺是否半选
        // }
      });
      this.judgeShopCheckAll(); //判断店铺是否全选
      this.judgeShopIsIndeter(); // 判断店铺是否半选
      // 未解决计数器问题搞一个对象存储
      this.objAllNum = Emccompute.queryAllNum({}, data);
      console.log(this.objAllNum);

      this.judgeSingleCategoryCheckAll(); //判断大类是否全选
      this.judgeSingleCategoryIsIndeter(); //判断大类是否半选

      // 判断是否全选
      // this.judgeEmcCheckAll(); //判断购物车是否全选
      // this.judgeEmcIsIndeter(); //判断购物车是否半选
      //  this.getSelectemcGoodsTotal();//获取购物车总数量及价格
    },
    handleCheckedGoods(shopCode) {
      // 更改单个商品选中或加减数量 前端综合判断选中状态
      let obj = JSON.parse(JSON.stringify(this.checkedForm.selectedData));
      this.$set(this.checkedForm, "selectedData", obj);
      this.judgeShopCheckAll(shopCode); //判断店铺是否全选
      this.judgeShopIsIndeter(shopCode); // 判断店铺是否半选

      this.judgeSingleCategoryCheckAll(); //判断购物车是否全选
      this.judgeSingleCategoryIsIndeter(); //判断购物车是否半选

      // this.judgeEmcCheckAll(); //判断购物车是否全选
      // this.judgeEmcIsIndeter(); //判断购物车是否半选
    },
    async handleCheckedGoodsChange(val, categoryCode, shopCode, goodCode) {
      const flag = await this.judgeCurrentCategoryCheckAll(categoryCode);
      console.log(flag);
      if (!flag) {
        return;
      }
      if (val) {
        this.checkedForm.selectedData[categoryCode][shopCode].push(goodCode);
      } else {
        this.checkedForm.selectedData[categoryCode][shopCode].splice(
          this.checkedForm.selectedData[categoryCode][shopCode].indexOf(
            goodCode
          ),
          1
        );
      }
      //店铺下商品选中
      // this.emcGoodsListData[index1].sons.splice(index2, 1, row); //更新选中状态
      this.handleCheckedGoods(shopCode);
      this.changeCheckCategoryFalse(categoryCode);
      //  this.getSelectemcGoodsTotal();//获取购物车总数量及价格
      this.handleSelected(); // 需要复原的地方
    },
    async handleCheckAllShopChange(val, categoryCode, code) {
      const flag = await this.judgeCurrentCategoryCheckAll(categoryCode);
      console.log(flag);
      if (!flag) {
        return;
      }
      //这里code是店铺级别code
      if (val) {
        this.checkedForm.selectedData[categoryCode][
          code
        ] = this.checkedShopGoods.goodsData[categoryCode][
          code
        ]; /**把店铺中所有商品赋值**/
      } else {
        this.checkedForm.selectedData[categoryCode][code] = [];
      }
      let obj = JSON.parse(JSON.stringify(this.checkedForm.selectedData));
      this.$set(this.checkedForm, "selectedData", obj);

      //取消半选
      /*let obj2 = {};
      obj2[code] = false;
      this.$set(this.checkedShopAll, "isIndeterminate", obj2);*/
      this.checkedShopAll.isIndeterminate[categoryCode][code] = false;

      // 店铺中全选
      // this.judgeEmcCheckAll(); //判断购物车是否全选
      // this.judgeEmcIsIndeter(); //判断购物车是否半选

      //this.getSelectemcGoodsTotal();//获取购物车总数量及价格

      this.judgeSingleCategoryCheckAll(); //判断大类是否全选
      this.judgeSingleCategoryIsIndeter(); //判断大类是否半选

      this.changeCheckCategoryFalse(categoryCode);

      this.handleSelected(); // 需要复原的地方
    },
    judgeCurrentCategoryCheckAll(categoryCode) {
      return new Promise((resolve, reject) => {
        const flag1 = Object.keys(this.checkedCategoryAll.selectedData).every(
          categoryCode =>
            this.checkedCategoryAll.selectedData[categoryCode] === false
        );
        const flag2 = Object.keys(
          this.checkedCategoryAll.isIndeterminate
        ).every(
          categoryCode =>
            this.checkedCategoryAll.isIndeterminate[categoryCode] === false
        );
        if (flag1 && flag2) {
          // 如果没有一个大类被选中选，则直接通过
          return resolve(true);
        }
        if (
          this.checkedCategoryAll.selectedData[categoryCode] ||
          this.checkedCategoryAll.isIndeterminate[categoryCode]
        ) {
          resolve(true);
        } else {
          this.$confirm(
            "不支持跨品类商品询价，确认是否更换已选择的商品分类？",
            "确认",
            {
              distinguishCancelAndClose: true,
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              customClass: "ccui-message-box-custom"
            }
          )
            .then(() => {
              console.log("确定");
              resolve(true);
            })
            .catch(() => {
              console.log("取消");
              resolve(false);
            });
        }
      });
    },
    async handleCheckCategoryChange(val, code) {
      const flag = await this.judgeCurrentCategoryCheckAll(code);
      console.log(flag);
      if (!flag) {
        return;
      }
      this.checkedCategoryAll.selectedData[code] = val;
      this.checkedCategoryAll.isIndeterminate[code] = false;
      //这里code是大类code
      if (val) {
        Object.keys(this.checkedForm.selectedData).forEach(categoryCode => {
          if (categoryCode === code) {
            Object.keys(this.checkedForm.selectedData[categoryCode]).forEach(
              shopCode => {
                this.checkedForm.selectedData[categoryCode][
                  shopCode
                ] = this.checkedShopGoods.goodsData[categoryCode][
                  shopCode
                ]; /**把店铺中所有商品赋值**/
              }
            );
            this.checkedCategoryAll.selectedData[categoryCode] = true;
            this.checkedCategoryAll.isIndeterminate[categoryCode] = false;
          } else {
            Object.keys(this.checkedForm.selectedData[categoryCode]).forEach(
              shopCode => {
                this.checkedForm.selectedData[categoryCode][shopCode] = [];
              }
            );
            this.checkedCategoryAll.selectedData[categoryCode] = false;
            this.checkedCategoryAll.isIndeterminate[categoryCode] = false;
          }
        });
      } else {
        Object.keys(this.checkedForm.selectedData[code]).forEach(shopCode => {
          this.checkedForm.selectedData[code][shopCode] = [];
        });
      }
      // if (val) {
      //   this.checkedForm.selectedData[code] = this.checkedShopGoods.goodsData[
      //     code
      //   ]; /**把店铺中所有商品赋值**/
      // } else {
      //   this.checkedForm.selectedData[code] = [];
      // }
      let obj = JSON.parse(JSON.stringify(this.checkedForm.selectedData));
      this.$set(this.checkedForm, "selectedData", obj);

      this.judgeShopCheckAll(); //判断店铺是否全选
      this.judgeShopIsIndeter(); //判断店铺是否半选

      //this.getSelectemcGoodsTotal();//获取购物车总数量及价格

      this.handleSelected(); // 需要复原的地方
    },
    // 将传入的code之外的大类取消勾选
    changeCheckCategoryFalse(code) {
      //这里code是大类code
      Object.keys(this.checkedForm.selectedData).forEach(categoryCode => {
        if (categoryCode !== code) {
          Object.keys(this.checkedForm.selectedData[categoryCode]).forEach(
            shopCode => {
              this.checkedForm.selectedData[categoryCode][shopCode] = [];
            }
          );
          this.checkedCategoryAll.selectedData[categoryCode] = false;
          this.checkedCategoryAll.isIndeterminate[categoryCode] = false;
        }
      });
      let obj = JSON.parse(JSON.stringify(this.checkedForm.selectedData));
      this.$set(this.checkedForm, "selectedData", obj);

      this.judgeShopCheckAll(); //判断店铺是否全选
      this.judgeShopIsIndeter(); //判断店铺是否半选
    },
    handleCheckAllEmcChange(val) {
      // 全选购物车中商品
      let selectedAllData = this.checkedForm.selectedData;
      console.log(selectedAllData, "+++++++++++++---------");
      console.log(this.checkedShopGoods, "---------");
      console.log(this.checkedShopAll.selectedData, "+++++++++");
      if (val) {
        for (let i of Object.keys(selectedAllData)) {
          selectedAllData[i] = JSON.parse(
            JSON.stringify(this.checkedShopGoods.goodsData)
          )[i];
          if (selectedAllData[i].length === 0) {
            this.checkedShopAll.selectedData[i] = false;
            this.checkedShopAll.isIndeterminate[i] = false;
          } else {
            this.checkedShopAll.selectedData[i] = true;
            this.checkedShopAll.isIndeterminate[i] = false;
          }
        }
      } else {
        for (let i of Object.keys(selectedAllData)) {
          selectedAllData[i] = [];
          this.checkedShopAll.selectedData[i] = false;
          this.checkedShopAll.isIndeterminate[i] = false;
        }
      }
      // 全选操作取消所有半选
      this.$set(this.checkedEmcAll, "isIndeterminate", { isIndeter: false });
      this.handleSelected();
    },
    handleSelected(rank) {
      //购物车选中商品
      let obj = {
        skuIds: this.selectedItems()
      };
      this.isCheckedState = false;
      selected(obj)
        .then(res => {
          if (res.data.code === "0") {
            if (rank && rank === 1) {
              // 提交走一遍选中接口不必要刷购物车页面
              //提交时触发要跳转页面
              // window.location.href = placeAnOrderUrl;
              if (this.isFlag) {
                window.location.href =
                  this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
                  "?CLIENT_ID=100110&CALLBACK_URL=" +
                  encodeURIComponent(placeAnOrderUrl + "?");
              }
            } else {
              this.getQuerCartsAll(false); //全部刷新商品列表
            }
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    selectedItems() {
      // 已选商品
      let [selectedSkus, selectedAllData] = [[], this.checkedForm.selectedData];
      Object.keys(selectedAllData).forEach(categoryCode => {
        Object.keys(selectedAllData[categoryCode]).forEach(shopCode => {
          selectedSkus.push.apply(
            selectedSkus,
            selectedAllData[categoryCode][shopCode]
          );
        });
      });
      // for (let i of Object.keys(selectedAllData)) {
      //   selectedSkus.push.apply(selectedSkus, selectedAllData[i]);
      // }
      return selectedSkus;
    },
    focusGoodsNum() {
      //当数量输入框获取焦点时
      this.isBlurFinish = false;
    },
    blurGoodsNum(e) {
      let that = this;
      setTimeout(() => {
        if (that.currClick === 0) {
          that.isBlurFinish = true;
        } else {
          that.currClick = 0;
        }
      }, 700);
      // this.isBlurFinish = true;
    },
    handleChangeGoodsNum(value, row, shopCode, categoryCode) {
      this.changeCheckCategoryFalse(categoryCode);
      /**最大输入99999 超过给出提示**/
      if (value > 9999999999) {
        this.$message.closeAll();
        this.$message({
          message: "商品数量不能大于9999999999",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
        // 这里可以改成两种啊 一种还原 一种value
        value = row.num;
        this.$nextTick(function() {
          this.$set(this.objAllNum, row.code, value);
        });
        // 选中当前商品
        if (
          this.checkedForm.selectedData[categoryCode][shopCode].indexOf(
            row.code
          ) === -1
        ) {
          if (this.addCardStatus.includes(row.skuStatus)) {
            this.checkedForm.selectedData[categoryCode][shopCode].push(
              row.code
            );
          }
        }
        this.handleSelected(); // 需要复原的地方
        //this.getQuerCartsAll(false);
        return false;
      } else {
        if (
          row.maxPurchaseNum !== null &&
          row.maxPurchaseNum !== undefined &&
          row.maxPurchaseNum !== "" &&
          value > row.maxPurchaseNum
        ) {
          this.$message.closeAll();
          this.$message({
            message: `单次购买数量不能大于${row.maxPurchaseNum}`,
            type: "error",
            showClose: true,
            ccuiCustom: true
          });
          value = row.num; //还原最初的
          // value = row.maxPurchaseNum;
          this.$nextTick(function() {
            this.$set(this.objAllNum, row.code, value);
          });
          // 选中当前商品
          if (
            this.checkedForm.selectedData[categoryCode][shopCode].indexOf(
              row.code
            ) === -1
          ) {
            if (this.addCardStatus.includes(row.skuStatus)) {
              this.checkedForm.selectedData[categoryCode][shopCode].push(
                row.code
              );
            }
          }
          this.handleSelected();
          return false;
        }
        this.$nextTick(function() {
          this.$set(this.objAllNum, row.code, value);
        });
        let area = `${this.defaultArea[0].code}_${this.defaultArea[1].code}_${this.defaultArea[2].code}`;
        let obj = {
          totalNum: value,
          skuId: row.code,
          area: area
        };
        this.isNumChange = false; // 操作数量改变
        this.isMonofile = true;
        modifyNumTotal(obj)
          .then(res => {
            if (res.data.code === "0") {
              /**操作数量即选中**/
              if (
                this.checkedForm.selectedData[categoryCode][shopCode].indexOf(
                  row.code
                ) === -1
              ) {
                if (this.addCardStatus.includes(row.skuStatus)) {
                  this.checkedForm.selectedData[categoryCode][shopCode].push(
                    row.code
                  );
                }
                this.handleCheckedGoods(shopCode); // 判断选中状态专用
              }
              if (row.skuStatus !== 10) {
                this.isNumChange = true; // 数量改变成功
                this.isBlurFinish = true; // 数量失焦事件已完成
                this.isMonofile = false;
              } else {
                // 单位限制
                this.isMonofile = true;
                this.isNumChange = false; // 数量改变成功
                this.isBlurFinish = false; // 数量失焦事件已完成
              }
              let iTime;
              let _this = this;
              clearTimeout(iTime);
              iTime = setTimeout(function() {
                //需要执行的事件
                _this.getQuerCartsAll(false); //改变数量刷新 需要复原的地方
              }, 360);
            }
          })
          .catch(e => {
            this.isNumChange = false; // 数量改变失败
            this.isBlurFinish = false; // 数量失焦事件未完成
            // 选中当前商品
            if (
              this.checkedForm.selectedData[categoryCode][shopCode].indexOf(
                row.code
              ) === -1
            ) {
              if (this.addCardStatus.includes(row.skuStatus)) {
                this.checkedForm.selectedData[categoryCode][shopCode].push(
                  row.code
                );
              }
            }
            this.handleSelected();
            this.getQuerCartsAll(false); //改变数量刷新
          });
      }
    },
    judgeShopCheckAll() {
      console.log(this.checkedForm.selectedData);
      console.log(this.checkedShopGoods.goodsData);
      console.log("categoryCode+++++++++++++++++++++");
      // 判断店铺是否全选
      let obj = JSON.parse(JSON.stringify(this.checkedForm.selectedData));
      Object.keys(obj).forEach(categoryCode => {
        Object.keys(obj[categoryCode]).forEach(shopCode => {
          if (
            obj[categoryCode][shopCode].length ===
              this.checkedShopGoods.goodsData[categoryCode][shopCode].length &&
            obj[categoryCode][shopCode].length !== 0
          ) {
            this.checkedShopAll.selectedData[categoryCode][shopCode] = true;
          } else {
            this.checkedShopAll.selectedData[categoryCode][shopCode] = false;
          }
        });
      });
      // if (
      //   obj[categoryCode][shopCode].length ===
      //     this.checkedShopGoods.goodsData[categoryCode][shopCode].length &&
      //   obj[categoryCode][shopCode].length !== 0
      // ) {
      //   this.checkedShopAll.selectedData[categoryCode][shopCode] = true;
      // } else {
      //   this.checkedShopAll.selectedData[categoryCode][shopCode] = true;
      // }
    },
    judgeShopIsIndeter() {
      //判断店铺是否半选
      let obj = JSON.parse(JSON.stringify(this.checkedForm.selectedData));
      Object.keys(obj).forEach(categoryCode => {
        Object.keys(obj[categoryCode]).forEach(shopCode => {
          if (
            obj[categoryCode][shopCode].length ===
              this.checkedShopGoods.goodsData[categoryCode][shopCode].length ||
            obj[categoryCode][shopCode].length === 0
          ) {
            this.checkedShopAll.isIndeterminate[categoryCode][shopCode] = false;
          } else {
            this.checkedShopAll.isIndeterminate[categoryCode][shopCode] = true;
          }
        });
      });
      // if (
      //   obj[shopCode].length ===
      //     this.checkedShopGoods.goodsData[shopCode].length ||
      //   obj[shopCode].length === 0
      // ) {
      //   this.checkedShopAll.isIndeterminate[shopCode] = false;
      // } else {
      //   this.checkedShopAll.isIndeterminate[shopCode] = true;
      // }
    },
    judgeEmcCheckAll() {
      // 判断购物车是否全选
      let [selectedAllDataNum, selectedAllData] = [
        0,
        this.checkedForm.selectedData
      ];
      for (let i of Object.keys(selectedAllData)) {
        selectedAllDataNum += selectedAllData[i].length;
      }
      if (
        selectedAllDataNum !== 0 &&
        selectedAllDataNum === this.checkedEmcGoods.goodsData.all.length
      ) {
        this.$set(this.checkedEmcAll, "selectedData", { isChecked: true });
      } else {
        this.$set(this.checkedEmcAll, "selectedData", { isChecked: false });
      }
    },
    judgeEmcIsIndeter() {
      //判断购物车是否半选
      // selectedAllDataNum //已选择商品种类数量
      let [selectedAllDataNum, selectedAllData] = [
        0,
        this.checkedForm.selectedData
      ];
      for (let i of Object.keys(selectedAllData)) {
        selectedAllDataNum += selectedAllData[i].length;
      }
      if (
        selectedAllDataNum !== this.checkedEmcGoods.goodsData.all.length &&
        selectedAllDataNum !== 0
      ) {
        this.$set(this.checkedEmcAll, "isIndeterminate", { isIndeter: true });
      } else {
        this.$set(this.checkedEmcAll, "isIndeterminate", { isIndeter: false });
      }
    },
    judgeSingleCategoryCheckAll() {
      // 判断大类是否全选
      console.log(this.checkedFormCategory.selectedData);
      console.log(this.checkedCategoryGoods.goodsData);
      console.log(this.checkedForm.selectedData);
      console.log("this.checkedFormCategory.selectedData");
      Object.keys(this.checkedForm.selectedData).forEach(categoryCode => {
        // selectedAllDataNum //已选择商品种类数量
        let [selectedAllDataNum, selectedAllData] = [
          0,
          this.checkedForm.selectedData[categoryCode]
        ];
        for (let i of Object.keys(selectedAllData)) {
          selectedAllDataNum += selectedAllData[i].length;
        }
        if (
          selectedAllDataNum !== 0 &&
          selectedAllDataNum ===
            this.checkedCategoryGoods.goodsData[categoryCode].length
        ) {
          // this.$set(this.checkedEmcAll, "selectedData", { isChecked: true });
          this.checkedCategoryAll.selectedData[categoryCode] = true;
        } else {
          // this.$set(this.checkedEmcAll, "selectedData", { isChecked: false });
          this.checkedCategoryAll.selectedData[categoryCode] = false;
        }
      });
    },
    judgeSingleCategoryIsIndeter() {
      //判断大类是否半选
      Object.keys(this.checkedForm.selectedData).forEach(categoryCode => {
        // selectedAllDataNum //已选择商品种类数量
        let [selectedAllDataNum, selectedAllData] = [
          0,
          this.checkedForm.selectedData[categoryCode]
        ];
        for (let i of Object.keys(selectedAllData)) {
          selectedAllDataNum += selectedAllData[i].length;
        }
        if (
          selectedAllDataNum !==
            this.checkedCategoryGoods.goodsData[categoryCode].length &&
          selectedAllDataNum !== 0
        ) {
          // this.$set(this.checkedEmcAll, "isIndeterminate", { isIndeter: true });
          this.checkedCategoryAll.isIndeterminate[categoryCode] = true;
        } else {
          // this.$set(this.checkedEmcAll, "isIndeterminate", { isIndeter: false });
          this.checkedCategoryAll.isIndeterminate[categoryCode] = false;
        }
      });
    },
    /*getSelectemcGoodsTotal(){ // 获取总价格及购已选中商品种类
      let selectedAllDataNum = 0 //已选择商品种类数量
      let selectedAllData = this.checkedForm.selectedData;
      for (let i in selectedAllData) {
        selectedAllDataNum += selectedAllData[i].length;
      }
      this.selectemcGoodsNum = selectedAllDataNum

    },*/
    deletedEmcGoods() {
      // 删除所选购物车商品
      let obj = {
        skuIds: this.selectedItems()
      };
      // 初始化已选择的数据
      this.initCheckFrom();

      this.handleDeletedSku(obj);
    },
    removeEmcGoods() {
      // 移除所选购物车商品
      let obj = {
        skuIds: this.selectedItems()
      };
      this.handleRmoveSku(obj);
    },
    deletedCurr(row, pRow, categoryItem) {
      //删除失效的商品
      let obj = {
        skuIds: [row.code]
      };
      if (pRow) {
        this.checkedForm.selectedData[categoryItem.code][pRow.code].splice(
          this.checkedForm.selectedData[categoryItem.code][pRow.code].indexOf(
            row.code
          ),
          1
        );
      }
      this.handleDeletedSku(obj);
    },
    removeCurr(row) {
      //移除当前行
      console.log("移到我的关注");
      /*      let obj = {
        skuIds: [row.code]
      };
      this.handleRmoveSku(obj);*/
    },
    initCheckFrom() {
      // 初始化已选择的商品
      for (let i of Object.keys(this.checkedForm.selectedData)) {
        this.checkedForm.selectedData[i] = [];
      }
    },
    handleDeletedSku(obj) {
      if (obj.skuIds.length === 0) {
        this.$message.closeAll();
        this.$message({
          message: "请至少选择一件商品",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
        return false;
      }
      deleteSku(obj)
        .then(res => {
          if (res.data.code === "0") {
            /*let myEvent = new Event('resize');
            window.dispatchEvent(myEvent);*/
            this.getQuerCartsAll(false);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    handleRmoveSku(obj) {},
    inquiryPrice() {
      const arr = [];
      Object.keys(this.checkedCategoryAll.isIndeterminate).forEach(
        categoryCode => {
          if (this.checkedCategoryAll.isIndeterminate[categoryCode]) {
            arr.push(true);
          }
        }
      );
      Object.keys(this.checkedCategoryAll.selectedData).forEach(
        categoryCode => {
          if (this.checkedCategoryAll.selectedData[categoryCode]) {
            arr.push(true);
          }
        }
      );
      if (arr.length === 0) {
        return this.$message({
          message: "请至少选择一件商品",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
      }
      if (arr.length > 1) {
        return this.$message({
          message: "请选择同类的商品进行询价，不支持跨分类商品询价",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
      }
      window.location.href =
        this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
        "?CLIENT_ID=100110&CALLBACK_URL=" +
        encodeURIComponent(inquiryPriceUrl + "?sourceSystem=2");
    },
    submitOrder(e, n) {
      if (Cookies.get("backCartCartData")) {
        let backCartCartData = JSON.parse(Cookies.get("backCartCartData"));
        Cookies.set("formCartSelect", JSON.stringify(backCartCartData), {
          path: "/",
          domain: "iccec.cn"
        });
      }

      Cookies.remove("backCartCartNum", {
        path: "/",
        domain: "iccec.cn"
      });

      let length = 0;
      for (const key in this.checkedForm.selectedData) {
        if (this.checkedForm.selectedData[key].length !== 0) {
          length = 1;
        }
      }
      if (length === 0) {
        this.isFlag = false;
      } else {
        this.isFlag = true;
      }
      // 之后需要限制一秒内不能提交
      if (e.target.className === "emc-all-submit-order") {
        this.currClick = 1;
      }
      if (this.isBlurFinish === false) {
        let that = this;
        if (n !== 2) {
          setTimeout(() => {
            that.submitOrder(e, 2);
            that.isBlurFinish = true; // 为防止submitOrder优先于改变数量接口
            that.isMonofile = true;
          }, 300);
        }
        this.currClick = 0; // 通不过都重置为0
        return false;
      }
      if (this.isBlurFinish === true && n === undefined) {
        // 提交订单
        this.submitLastOrder();
      } else if (this.isBlurFinish === true && this.isNumChange === true) {
        //提交订单
        if (!this.isMonofile) {
          this.submitLastOrder();
        } else {
          this.$message.closeAll();
          this.$message({
            message: "请至少选择一件商品",
            type: "error",
            showClose: true,
            ccuiCustom: true
          });
        }
      } else {
        this.currClick = 0; // 通不过都重置为0
      }
    },
    submitLastOrder() {
      let selectedSkus = this.selectedItems();
      if (selectedSkus.length === 0) {
        this.$message.closeAll();
        this.$message({
          message: "请至少选择一件商品",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
        this.currClick = 0; // 通不过都重置为0
        return false;
      }
      if (selectedSkus.length > 50) {
        this.$message.closeAll();
        this.$message({
          message: "单次购买商品种类不能超过50种，请重新挑选。",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
        this.currClick = 0; // 通不过都重置为0
        return false;
      }

      this.handleSelected(1);
    },
    handleScrollx(source) {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (!scrollTop && document.body.scrollHeight - this.clientHeight > 400) {
        this.emcTotalFixDefault = true;
        if (
          source === 1 &&
          (!!window.ActiveXObject || "ActiveXObject" in window)
        ) {
          // 判断是ie浏览器
          setTimeout(() => {
            this.emcTotalFixDefault = false;
          }, 200);
          setTimeout(() => {
            this.emcTotalFixDefault = true;
          }, 400);
        }
      }

      if (scrollTop && this.clientHeight + scrollTop <= this.emcTotalOffTop) {
        // this.emcTotalFix = true;
        this.emcTotalFixDefault = true;
      } else if (
        scrollTop &&
        this.clientHeight + scrollTop > this.emcTotalOffTop
      ) {
        // this.emcTotalFix = false;
        this.emcTotalFixDefault = false;
      }
    },
    getInfoTree() {
      qryUnitOrgTree({})
        .then(res => {
          if (res.data.code === "0") {
            this.unitSelectData = res.data.data.orgData;
            const orgInfoCookie = Cookies.get("orgInfo");
            if (orgInfoCookie && JSON.parse(orgInfoCookie).orgId) {
              const orgInfo = JSON.parse(orgInfoCookie);
              const orgId = orgInfo.orgId;
              this.unitSelectData = res.data.data.orgData.filter(item => {
                return item.orgId === orgId;
              });
              this.purchaseOrgId = orgId;
              this.purchaseUndertakeOrgIdValue = orgInfo.name;
            } else if (
              Cookies.get("backCartCartData") &&
              JSON.parse(Cookies.get("backCartCartData")).deptId &&
              this.backCartCartNum === 1
            ) {
              let dataArr = [JSON.parse(Cookies.get("backCartCartData"))];
              this.purchaseOrgId = dataArr[0].orgId;
              this.purchaseUndertakeOrgIdValue = dataArr[0].orgDeptName;
            } else {
              if (res.data.data.orgData.length > 0) {
                this.purchaseOrgId = res.data.data.orgData[0].child[0].orgId;
                this.purchaseUndertakeOrgIdValue =
                  res.data.data.orgData[0].child[0].orgDeptName;
              }
            }
          }
          this.GetQryDefault();
          // this.getQuerCartsAll(true);
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScrollx, true);
  }
};
</script>
<style lang="scss" scoped>
.category-item {
  margin-top: 10px;
  font-size: 13px;
  color: #4a4a4a;
  .emc-checkbox {
    margin-right: 15px;
  }
}
.goods-detail {
  .goods-img {
    left: 0 !important;
  }
  .goods-name {
    padding-left: 70px !important;
  }
}
.goods-shop-list {
  .deletedCurr {
    margin-top: 0 !important;
  }
}
.goods-name {
  height: initial !important;
  line-height: initial !important;
  display: flex !important;
  flex-direction: column !important;
  .icon-shopingName {
    // width: 48px;
    width: auto;
  }
}
.flex {
  display: flex;
  float: right;
  padding-right: 21px;
}
.invoiceSubject {
  float: left;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.icon-shopingName {
  // width: 51px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  background: #ff142f;
  border-radius: 2px;
  color: #fff;
  margin-right: 5px;
  font-size: 12px;
  padding: 0px 3px;
  display: inline-block;
  float: left;
  margin-top: 12px;
  &.shop-shopName {
    background: #7066ff;
  }
}
.icon-shopingType {
  // width: 51px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  background: #ff6e26;
  border-radius: 2px;
  color: #fff;
  margin-right: 5px;
  font-size: 12px;
  padding: 0px 3px;
  display: inline-block;
  float: left;
  margin-top: 12px;
}
.shopName {
  display: block;
  // max-width: 155px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  float: left;
}
.low-price-label {
  border-radius: 4px;
  border: 1px solid #34ac2c;
  font-size: 12px;
  padding: 1px 6px;
  color: #34ac2c;
  user-select: none;
  // margin-left: 15px;
  // margin-right: 10px;
}
</style>
